<div
  class="card-arrival-child-container"
  (click)="clickArrivalStatusDetail($event)"
>
  <img class="card-arrival-child-photo" [src]="(gatesMonitor?.child)!.photo" />
  <div class="card-arrival-child-left"></div>
  <div class="card-arrival-child-right">
    <div class="card-arrival-child-superior">
      <div class="card-arrival-child-detail">
        <div class="card-arrival-child-name">
          {{ (gatesMonitor?.child)!.name }}
        </div>
        <div class="card-arrival-child-icon">
          <div
            *ngIf="gatesMonitor?.status == 'UNPREDICTABLE'"
            class="redicon"
          ></div>
          <img src="{{ gatesMonitor?.iconVehicle }}" />
        </div>
      </div>
      <div class="card-arrival-child-classroom">
        <span>{{ gatesMonitor?.classRoomDescription }}</span>
      </div>
    </div>
    <div class="card-arrival-child-inferior">
      <div class="card-arrival-forecast" *ngIf="gatesMonitor?.isResponsable">
        <div *ngIf="gatesMonitor?.status === 'GOING'">
          {{ gatesMonitor?.textForecast }}:<span> {{ timeRemaining }} </span>
        </div>
        <div
          *ngIf="
            gatesMonitor?.status === 'ARRIVED' ||
            gatesMonitor?.status === 'CANCELED'
          "
        >
          <span>{{ gatesMonitor?.textForecast }}</span>
        </div>
        <div *ngIf="gatesMonitor?.status === 'UNPREDICTABLE'">
          {{ gatesMonitor?.textForecast }}:<span>indisponível</span>
        </div>
      </div>
      <div class="card-arrival-forecast" *ngIf="!gatesMonitor?.isResponsable">
        <span>Aguardando liberação</span>
      </div>
      <button
        [ngClass]="releaseButton"
        [disabled]="enableReleaseButton()"
        (click)="releaseChild(gatesMonitor?.idArrival!)"
        mat-raised-button
      >
        Liberar
      </button>
    </div>
  </div>
</div>
